import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './tailwind.css';
import App from './App';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { startVersionCheck } from './utils/versionCheck';

const rootElement = document.getElementById('root');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <App />,
);

// Register service worker (production only — dev rebuilds invalidate the SW
// constantly and confuse hot reload). Failure here is non-fatal.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((err) => console.warn('SW registration failed:', err));
  });
}

// Start polling /version.json so VersionBanner can prompt users running stale bundles.
startVersionCheck();
